/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Show_FilmstripInputs */



/**
* | output |
* | --- |
* | "Show Film Strip" |
*
* @param {Options_Editor_Show_FilmstripInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_show_filmstrip = /** @type {((inputs?: Options_Editor_Show_FilmstripInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Show_FilmstripInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher la pellicule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Filmstreifen zeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra la striscia di pellicola")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать кинопленку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar tira de película")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("放映胶片")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィルムストリップを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिल्म स्ट्रिप दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exibir tira de filme")
	return /** @type {LocalizedString} */ ("Show Film Strip")
});